/**
 * Implementation of Purchase LTD component
 *
 * @author - Harsh Tomar
 */

// Dependencies
import { cloneElement, ReactElement, useCallback, useState } from "react";
import { BiLoaderAlt } from "react-icons/bi";
import { useGetCurrentUser } from "../../api/reactQuery";
import Modal from "../Modal";

type Props = {
  planId: number;
  cta: ReactElement;
  onPaymentSuccess?: () => void;
};

export default function PurchaseLTD(props: Props) {
  const [initiatingPayment, setInitiatingPayment] = useState(false);
  const { data, refetch } = useGetCurrentUser(true);
  const [verifyingPayment, setVerifyingPayment] = useState(false);

  const _initiatePayment = useCallback(() => {
    //@ts-ignore
    const Paddle = window.Paddle;

    Paddle.Checkout.open({
      product: props.planId,
      email: data?.email,
      marketingConsent: true,
      quantity: 1,
      allowQuantity: false,
      // passthrough: JSON.stringify({ orderId: order._id }),
      successCallback: async () => {
        // setConfirmModal(false);
        setInitiatingPayment(false);
        // setPaymentSuccess(true);
        setVerifyingPayment(true);

        // Timeout is necessary so that webhook is handled at backend from paddle
        setTimeout(async () => {
          await refetch();
          setVerifyingPayment(false);
        }, 2000);
        props.onPaymentSuccess && props.onPaymentSuccess();
      },
    });
  }, [props.onPaymentSuccess, data]);

  const Element = cloneElement(props.cta, { onClick: _initiatePayment });

  return (
    <>
      {Element}

      <Modal visible={verifyingPayment} onClose={() => {}}>
        <div className="p-4">
          <div className="flex justify-center items-center">
            <BiLoaderAlt className="animate-spin" size={28} />
          </div>
          <p className="text-center">Verifying Payment</p>
        </div>
      </Modal>
    </>
  );
}
